import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chart1",
  class: "justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_grid = _resolveComponent("q-spinner-grid")!
  const _component_center = _resolveComponent("center")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_q_spinner_grid, {
              style: {"height":"415px"},
              color: "primary",
              size: "2.5em"
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_apexchart, {
          key: 1,
          ref: "lineChart",
          type: "line",
          height: "513",
          options: _ctx.chartOptions,
          series: _ctx.series
        }, null, 8, ["options", "series"]))
  ]))
}